// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"90d1985f","268":"413b875b","393":"b585ba53","427":"a09dc63c","453":"2f11d6a5","455":"c96e5591","639":"c63444c8","977":"2df0e5b4"}[chunkId] + ".chunk.js";
};